import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';

const KeyFeatureItem = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ bgColor }) => bgColor || 'inherit'};
  padding: 20px;

  @media(max-width: ${device.laptop}) {
    text-align: center;
  }

  * {
    margin-bottom: 10px;
  }
`;

export default ({ className, ...rest }) => <KeyFeatureItem className={className} {...rest} />;
